// extracted by css-extract-rspack-plugin
module.exports =  {"sectionwithad":"Ns4vo","sliderBlk":"dztMO","bannerSlider":"wJLzQ","withborder":"wPh1R","fakeLink":"FNvtP","nolink":"g31eZ"};